exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.supplierName[data-v-b4b8fba6]{\n    line-height: 1rem;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-b4b8fba6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Companies.vue
// module id = 2275
// module chunks = 0